import React, { useState } from "react";
import Chip from "@mui/material/Chip";
import { Box } from "@mui/material";
import { GRUPOS } from "../Grupo/Grupo-Api";
import IaxGroupSummaryDialog from "./IaxGroupSummaryDialog";

const IaxGroupSummary = ({ groups }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  switch (groups?.length) {
    case 0:
      return (
        <Box sx={{ textAlign: "center" }}>
          <Chip key={0} label="NINGÚN GRUPO ASIGNADO" color="default" />
        </Box>
      );
    case GRUPOS?.length:
      return (
        <Box sx={{ textAlign: "center" }}>
          <Chip key={0} label="TODOS LOS GRUPOS" color="default" />
        </Box>
      );
    default:
      return (
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            gap: 1,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {groups.slice(0, 14).map((group) => (
            <Chip key={group.id} label={group.nombre} color="default" />
          ))}
          {groups.length > 14 ? (
            <>
              <Chip
                key={0}
                onClick={handleOpen}
                label={"...ver más"}
                color="primary"
              />
              <IaxGroupSummaryDialog
                open={open}
                onClose={handleClose}
                groups={groups}
              />
            </>
          ) : (
            ""
          )}
        </Box>
      );
  }
};

export default IaxGroupSummary;
